<template lang="pug">
  div.auth.request-reset-password
    div.modal.login
      div.modal.login-inner

      transition(name="fade")
        div(:style="{'z-index': 9999}").smallModal.showPasswordRecovery.open
          div.fixed-overlay.fixed-overlay__modal
            div.modal
              div.modal_container
                div.header
                  h1.title {{$translate('Восстановление пароля')}}
                div.body-wrapper
                  e-form(:formValidator="formValidator")
                    div.body
                      div.col
                        e-form-subtitle(text="Ссылка для восстановления пароля будет отправлена на email")

                        e-form-group(
                        label="E-mail"
                        name="email"
                        validationRule="email"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                        )

                div.footer
                  div.actions-filter-panel.actions-filter-panel--right
                    div
                      button(
                      type="button"
                      @click="goBack()"
                      ).actions-filter-panel__button.standart.standart-noborder {{$translate('Назад')}}
                      button(
                      type="button"
                      @click="sendForm()"
                      ).actions-filter-panel__button.standart {{$translate('Восстановить')}}
</template>

<script>
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import {auth} from '../../api/api-endpoints'

  export default {
    mixins: [formBaseMixin],
    title: function () {
      return this.$translate('Восстановление пароля')
    },
    data () {
      return {
        tabView: 'tab1',
        fields: {
          email: ''
        }
      }
    },
    methods: {
      goBack () {
        return this.$router.push({path: '/login'})
      },
      onSuccess () {
        this.showOnSuccess(
          this.$translate('Ссылка для восстановления пароля была отправлена')
        )
        this.unFreezeFrom()
        this.goBack()
      },
      getUpdateOrCreateUrl () {
        return auth.reset()
      },
      getItemEndpoint () {
        return null
      }
    }
  }
</script>

